// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pULl","content":"styles_content__2sewt","tableWrap":"styles_tableWrap__3ThVg"};